import React from 'react';
import { Link } from 'react-router-dom';

const NavOne = () => {
    return(
            <>
                <div className="header-upper">
                    <div className="default-container">
                        <div className="clearfix">
                            <div className="pull-left logo-box">
                                <div className="logo">
                                    <Link to="/"><img src="images/logo.png" alt="logo" title="Logo" /></Link>
                                </div>
                            </div>
                            <div className="nav-outer clearfix">
                                <div className="button-box-tow">
                                    <Link to="/contact-us" className="o-btn btn-style-one">Ask For Quote</Link>
                                </div>
                                <nav className="main-menu navbar-expand-md">
                                    <div className="navbar-header">
                                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                        <i className="icon-bar"></i>
                                        <i className="icon-bar"></i>
                                        <i className="icon-bar"></i>
                                    </button>
                                    </div>
                                    <div className="navbar-collapse collapse clearfix" id="navbarSupportedContent">
                                        <ul className="navigation clearfix">
                                            <li className="dropdown"><Link to="#">Home</Link>
                                                <ul>
                                                    <li><Link to="/">Home 01</Link></li>
                                                    <li><Link to="/home-2">Home 02</Link></li>
                                                    <li><Link to="/home-3">Home 03</Link></li>
                                                    <li><Link to="/home-4">Home 04</Link></li>
                                                    <li className="dropdown"><Link to="#">Header</Link>
                                                        <ul>
                                                            <li><Link to="/">Header 01</Link></li>
                                                            <li><Link to="/home-2">Header 02</Link></li>
                                                            <li><Link to="/home-3">Header 03</Link></li>
                                                            <li><Link to="/home-4">Header 04</Link></li>
                                                        </ul>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li className="dropdown"><Link to="#">Pages</Link>
                                                <ul>
                                                    <li><Link to="/about-us-1">About Us 1</Link></li>
                                                    <li><Link to="/about-us-2">About Us 2</Link></li>
                                                    <li><Link to="/about-us-3">About Us 3</Link></li>
                                                    <li><Link to="/404">404</Link></li>
                                                </ul>
                                            </li>
                                            <li className="dropdown"><Link to="#">Attorney</Link>
                                                <ul>
                                                    <li><Link to="/attorney-full-width-1">Attorney Full Width</Link></li>
                                                    <li><Link to="/attorney-left-sidebar-three-grid-1">Attorney Three Grid / Left Sidebar</Link></li>
                                                    <li><Link to="/attorney-left-sidebar-two-grid-1">Attorney Two Grid / Left Sidebar</Link></li>
                                                    <li><Link to="/attorney-right-sidebar-three-grid-1">Attorney Three Grid / Right Sidebar</Link></li>
                                                    <li><Link to="/attorney-right-sidebar-two-grid-1">Attorney Two Grid / Right Sidebar</Link></li>
                                                    <li><Link to="/attorney-single-1">Attorney Single One</Link></li>
                                                    <li><Link to="/attorney-single-2">Attorney Single Two</Link></li>
                                                </ul>
                                            </li>
                                            <li className="dropdown"><Link to="#">Practice</Link>
                                                <ul>
                                                    <li><Link to="/practice">Practice Full Width</Link></li>
                                                    <li><Link to="/practice-left-sidebar">Practice Left Sidebar</Link></li>
                                                    <li><Link to="/practice-right-sidebar">Practice Right Sidebar</Link></li>
                                                    <li><Link to="/practice-single-left-sidebar">Practice Single Left Sidebar</Link></li>
                                                    <li><Link to="/practice-single-right-sidebar">Practice Single Right Sidebar</Link></li>
                                                </ul>
                                            </li>
                                            <li className="dropdown"><Link to="#">Blog</Link>
                                                <ul>
                                                    <li><Link to="/blog">Blog Full Width</Link></li>
                                                    <li><Link to="/blog-left-sidebar">Blog Left Sidebar</Link></li>
                                                    <li><Link to="/blog-right-sidebar">Blog Right Sidebar</Link></li>
                                                    <li><Link to="/blog-single-left-sidebar">Blog Single Left Sidebar</Link></li>
                                                    <li><Link to="/blog-single-right-sidebar">Blog Single Right Sidebar</Link></li>
                                                </ul>
                                            </li>
                                            <li className="dropdown"><Link to="#">Contact us</Link>
                                                <ul>
                                                    <li><Link to="/contact-us-1">Contact us 1</Link></li>
                                                    <li><Link to="/contact-us-2">Contact us 2</Link></li>
                                                    <li><Link to="/contact-us-3">Contact us 3</Link></li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </div>
                                </nav>
                                <div className="menu-search-box">
                                    <div className="dropdown">
                                        <button className="menu-sb-btn dropdown-toggle" type="button" id="dropdownMenu3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i className="fa fa-search"></i></button>
                                        <ul className="dropdown-menu pull-right search-panel" aria-labelledby="dropdownMenu3">
                                            <li className="panel-outer">
                                                <div className="form-container">
                                                    <form method="post" action="#">
                                                        <div className="form-group">
                                                            <input type="search" name="field-name" value="" placeholder="Search Here" required />
                                                            <button type="submit" className="search-btn"><i className="fa fa-search"></i></button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="sticky-header">
                    <div className="default-container clearfix">
                        <div className="logo pull-left">
                            <Link to="/" className="img-responsive"><img src="images/logo-small.png" alt="logo" title="Logo" /></Link>
                        </div>
                        <div className="right-col pull-right">
                            <nav className="main-menu navbar-expand-md">
                                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent1" aria-controls="navbarSupportedContent1" aria-expanded="false" aria-label="Toggle navigation">
                                <i className="icon-bar"></i>
                                <i className="icon-bar"></i>
                                <i className="icon-bar"></i>
                            </button>
                                <div className="navbar-collapse collapse clearfix" id="navbarSupportedContent1">
                                    <ul className="navigation clearfix">
                                        <li className="dropdown"><Link to="#">Home</Link>
                                            <ul>
                                                <li><Link to="/">Home 01</Link></li>
                                                <li><Link to="/home-2">Home 02</Link></li>
                                                <li><Link to="/home-3">Home 03</Link></li>
                                                <li><Link to="/home-4">Home 04</Link></li>
                                                <li className="dropdown"><Link to="#">Header</Link>
                                                    <ul>
                                                        <li><Link to="/">Header 01</Link></li>
                                                        <li><Link to="/home-2">Header 02</Link></li>
                                                        <li><Link to="/home-3">Header 03</Link></li>
                                                        <li><Link to="/home-4">Header 04</Link></li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="dropdown"><Link to="#">Pages</Link>
                                            <ul>
                                                <li><Link to="/about-us-1">About Us 1</Link></li>
                                                <li><Link to="/about-us-2">About Us 2</Link></li>
                                                <li><Link to="/about-us-3">About Us 3</Link></li>
                                                <li><Link to="/404">404</Link></li>
                                            </ul>
                                        </li>
                                        <li className="dropdown"><Link to="#">Attorney</Link>
                                            <ul>
                                                <li><Link to="/attorney-full-width-1">Attorney Full Width</Link></li>
                                                <li><Link to="/attorney-left-sidebar-three-grid-1">Attorney Three Grid / Left Sidebar</Link></li>
                                                <li><Link to="/attorney-left-sidebar-two-grid-1">Attorney Two Grid / Left Sidebar</Link></li>
                                                <li><Link to="/attorney-right-sidebar-three-grid-1">Attorney Three Grid / Right Sidebar</Link></li>
                                                <li><Link to="/attorney-right-sidebar-two-grid-1">Attorney Two Grid / Right Sidebar</Link></li>
                                                <li><Link to="/attorney-single-1">Attorney Single One</Link></li>
                                                <li><Link to="/attorney-single-2">Attorney Single Two</Link></li>
                                            </ul>
                                        </li>
                                        <li className="dropdown"><Link to="#">Practice</Link>
                                            <ul>
                                                <li><Link to="/practice">Practice Full Width</Link></li>
                                                <li><Link to="/practice-left-sidebar">Practice Left Sidebar</Link></li>
                                                <li><Link to="/practice-right-sidebar">Practice Right Sidebar</Link></li>
                                                <li><Link to="/practice-single-left-sidebar">Practice Single Left Sidebar</Link></li>
                                                <li><Link to="/practice-single-right-sidebar">Practice Single Right Sidebar</Link></li>
                                            </ul>
                                        </li>
                                        <li className="dropdown"><Link to="#">Blog</Link>
                                            <ul>
                                                <li><Link to="/blog">Blog Full Width</Link></li>
                                                <li><Link to="/blog-left-sidebar">Blog Left Sidebar</Link></li>
                                                <li><Link to="/blog-right-sidebar">Blog Right Sidebar</Link></li>
                                                <li><Link to="/blog-single-left-sidebar">Blog Single Left Sidebar</Link></li>
                                                <li><Link to="/blog-single-right-sidebar">Blog Single Right Sidebar</Link></li>
                                            </ul>
                                        </li>
                                        <li className="dropdown"><Link to="#">Contact us</Link>
                                        <ul>
                                            <li><Link to="/contact-us-1">Contact us 1</Link></li>
                                            <li><Link to="/contact-us-2">Contact us 2</Link></li>
                                            <li><Link to="/contact-us-3">Contact us 3</Link></li>
                                        </ul>
                                    </li>
                                    </ul>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
        </>
    )
}

export default NavOne;